import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {ContentService} from "../_services/content.service";
import {DynamicSettings} from "../_types/shared";

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrl: './privacy.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivacyComponent {
    privacyDynamic: string = '';
    settings: DynamicSettings | null = null;

    constructor(private authService: AuthService,
                private contentService: ContentService) {
        this.authService.getDynamicSettings().then((r): void => {
            this.settings = r;
        });

        this.contentService.getPrivacyPolicy().subscribe({
            next: r => {
                if (r && r.rendered) {
                    this.privacyDynamic = r.rendered;
                }
            }, error: error => {
                console.error(error)
            }
        });
    }
}
